import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M10.8 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0-7.167a1 1 0 0 1 1 1V12.5a1 1 0 1 1-2 0v-1.667a1 1 0 0 1 1-1ZM11.8 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" fill="currentColor" />' }
  })
);